import { render, staticRenderFns } from "./LogoBGFDev.vue?vue&type=template&id=0318e953&"
import script from "./LogoBGFDev.vue?vue&type=script&lang=js&"
export * from "./LogoBGFDev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports